export default class Slider {
    constructor(selector) {
        if (!selector) selector = '.slider';
        this.slider = document.querySelector(selector);
        this.activeSlide = this.slider.querySelector('.active');
    }

    prev() {
        this.activeSlide.classList.remove('active');
        this.activeSlide = this.activeSlide.previousElementSibling.classList.contains('gallery__image')
            ? this.activeSlide.previousElementSibling
            : this.slider.querySelector('.gallery__image:last-child');
        this.activeSlide.classList.add('active');
    }

    next() {
        this.activeSlide.classList.remove('active');
        this.activeSlide = this.activeSlide.nextElementSibling
            ? this.activeSlide.nextElementSibling
            : this.slider.querySelector('.gallery__image');
        this.activeSlide.classList.add('active');
    }

    goto(id) {
        if (this.activeSlide) this.activeSlide.classList.remove('active');
        this.activeSlide = document.getElementById(id);
        this.activeSlide.classList.add('active');
    }

    open() {
        this.slider.classList.add('off');
    }

    close() {
        if (this.activeSlide) this.activeSlide.classList.remove('active');
        this.slider.classList.remove('off');
    }
}


// WEBPACK FOOTER //
// ./schreinerei-gfeller/Frontend/js/modules/slider.js